import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import LoadsPage from "components/LoadsPage";
import {
  useAddBatteryStateLoadsMutation,
  useGetBatteryStateLoadsByCommunityIdPaginationQuery,
} from "state/batteries/batteryApiSlice";

function ManageBatteryStateLoads({ noWrapper }) {
  const { t } = useTranslation(["internalLoads"]);
  return (
    <LoadsPage
      title={t("pages.battery_state.title")}
      subtitle={t("pages.battery_state.subtitle")}
      taskType="BATTERY_STATE_LOAD"
      templateHref="/docs/template_bateria.csv"
      addMutation={useAddBatteryStateLoadsMutation}
      noWrapper={noWrapper}
      table={{
        query: useGetBatteryStateLoadsByCommunityIdPaginationQuery,
        resourceField: "storage_id",
        resourceLabel: t("pages.battery_state.table.columns.storage"),
        resourceType: "STORAGE",
        valueLabel: { field: "charge_state", label: t("shared.columns.charge_state") },
        valueDigits: 4,
      }}
    />
  );
}

ManageBatteryStateLoads.propTypes = {
  noWrapper: PropTypes.bool,
};

ManageBatteryStateLoads.defaultProps = {
  noWrapper: false,
};

export default ManageBatteryStateLoads;
